export default __webpack_public_path__ + "static/cp-screens-vertical-79ffdc890fba51887ad8769d29762be3.jpg";